/**
 * Simple event emitter for auth events
 */

import type { AuthEvent, EventHandler } from "./types";

type EventMap = Record<string, EventHandler[]>;

export class EventEmitter {
  private events: EventMap = {};

  /**
   * Subscribe to an event
   */
  on(event: AuthEvent, handler: EventHandler): void {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(handler);
  }

  /**
   * Unsubscribe from an event
   */
  off(event: AuthEvent, handler: EventHandler): void {
    if (!this.events[event]) {
      return;
    }
    this.events[event] = this.events[event].filter((h) => h !== handler);
  }

  /**
   * Emit an event with arguments
   */
  emit(event: AuthEvent, ...args: any[]): void {
    if (!this.events[event]) {
      return;
    }
    this.events[event].forEach((handler) => {
      try {
        handler(...args);
      } catch (error) {
        console.error(`[AuthClient] Error in event handler for "${event}":`, error);
      }
    });
  }

  /**
   * Remove all event listeners
   */
  removeAllListeners(): void {
    this.events = {};
  }
}
